<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <div class="userCnt">
          <div class="info-l">
            <div class="profilePict" v-if="d.avatar"
              :style="{'background-image': `url(${d.avatar})`}"></div>
            <div class="profilePict noImg" v-else></div>
          </div>
          <div class="info-r">
            <h4>Data Diri</h4>
            <div class="infoItem">
              <span>Nama</span>
              {{d.name}}
            </div>
            <div class="infoItem">
              <span>Tanggal Lahir</span>
              <template v-if="d.birthdate">{{d.birthdate | moment('YYYY/MM/')}}XX</template>
              <template v-else><i>Unknown</i></template>
            </div>
            <div class="infoItem">
              <span>Jenis Kelamin</span>
              <template v-if="d.gender">{{d.gender}}</template>
              <template v-else><i>Unknown</i></template>
            </div>
            <div class="divider"></div>
            <h4>Kontak</h4>
            <div class="infoItem">
              <span>Alamat Email</span>
              <template v-if="d.email">{{d.email}}</template>
              <template v-else><i>Unknown</i></template>
            </div>
            <div class="infoItem">
              <span>Mo. Telp.</span>
              <template v-if="d.phone">{{d.phone}}</template>
              <template v-else><i>Unknown</i></template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      show: false,
      next: null,
      d: null,
    };
  },
  methods: {
    open(d, n) {
      this.loading = false;
      this.next = n;
      this.show = true;
      this.d = d;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 620px;
    margin: auto;
    border-radius: 5px;
    padding: 30px 40px 20px;
    box-sizing: border-box;
    overflow: hidden;
    transition: all .3s ease;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    .userCnt{
      display: flex;
      .info-l{
        width: 200px;
        .profilePict{
          height: 200px;
          border-radius: 5px;
          background-color: #ccc;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          max-width: 100%;
          &.noImg{
            background-image: url(../assets/user-line.png);
            opacity: .36;
            background-size: 46% auto;
          }
        }
      }
      .info-r{
        width: calc(100% - 200px);
        box-sizing: border-box;
        padding-left: 30px;
        h4{
          margin: 10px 0 6px;
          font-size: 18px;
        }
        .divider{
          height: 12px;
        }
        .infoItem{
          border-bottom: #eee 1px dashed;
          display: flex;
          padding: 4px 0;
          i{
            color: #999;
          }
          span{
            margin-right: auto;
            color: #767676;
          }
        }
      }
    }
  }
}
</style>
